<div class="srm-overlay" (click)="onCancel()">
  <div class="srm-modal srm-modal--wide" (click)="$event.stopPropagation()">
    <header class="srm-head">
      <div class="srm-head-titleblock">
        <h2 class="srm-title">Section &amp; Row</h2>
        <p class="srm-sub">Define the sections and rows to test — each seeds a test row</p>
      </div>
      <button type="button" class="srm-close" (click)="onCancel()" aria-label="Close">×</button>
    </header>

    <div class="srm-body">
      <div class="srm-field">
        <span class="srm-label">Add a section</span>
        <div class="srm-toolbar">
          <input type="text" class="srm-input" placeholder="e.g. 101"
                 aria-label="Add a section"
                 [(ngModel)]="sectionInput"
                 (keyup.enter)="addSection()" style="flex:1" />
          <button type="button" class="srm-btn srm-btn-save" (click)="addSection()">Add</button>
        </div>
        <span class="srm-hint">
          Leave a section's rows empty to test the whole section, or add specific rows below.
        </span>
      </div>

      <div class="srm-list" *ngIf="entries.length">
        <div class="srm-list-scroll">
          <div class="srm-section-entry" *ngFor="let entry of entries; trackBy: trackEntry">
            <div class="srm-list-row">
              <span class="srm-row-name">Section {{ entry.section }}</span>
              <span class="srm-row-meta">{{ entry.rows.length ? entry.rows.length + ' row(s)' : 'Whole section' }}</span>
              <button type="button" class="srm-chip-x" (click)="removeSection(entry)"
                      aria-label="Remove section">×</button>
            </div>

            <div class="srm-section-rows">
              <div class="srm-chip-row" *ngIf="entry.rows.length">
                <span class="srm-chip" *ngFor="let row of entry.rows; trackBy: trackRow">
                  Row {{ row }}
                  <button type="button" class="srm-chip-x" (click)="removeRow(entry, row)"
                          aria-label="Remove row">×</button>
                </span>
              </div>
              <div class="srm-toolbar">
                <input type="text" class="srm-input" placeholder="Add a row (e.g. AA)"
                       aria-label="Add a row"
                       [(ngModel)]="entry.rowInput"
                       (keyup.enter)="addRow(entry)" style="flex:1" />
                <button type="button" class="srm-link-btn" (click)="addRow(entry)">Add row</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="srm-empty" *ngIf="!entries.length">
        No sections added yet. Add a section above to start.
      </div>
    </div>

    <footer class="srm-foot">
      <button type="button" class="srm-btn srm-btn-cancel" (click)="onCancel()">Cancel</button>
      <button type="button" class="srm-btn srm-btn-save"
              [disabled]="!entries.length" (click)="onConfirm()">Save rule</button>
    </footer>
  </div>
</div>
